import { render, staticRenderFns } from "./ImmediateMessagePopup.vue?vue&type=template&id=54932cf9&scoped=true&"
import script from "./ImmediateMessagePopup.vue?vue&type=script&lang=js&"
export * from "./ImmediateMessagePopup.vue?vue&type=script&lang=js&"
import style0 from "./ImmediateMessagePopup.vue?vue&type=style&index=0&id=54932cf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54932cf9",
  null
  
)

export default component.exports